import { tourFactory, getTourStepButtons } from './tourUtils';

const campaignTour = tourFactory('campaign');

campaignTour.addStep({
  text: 'A tela de campanha está de cara nova. Gostaria de fazer um tour?',
  buttons: [
    { text: 'Cancelar', action: campaignTour.cancel },
    { text: 'Iniciar', action: campaignTour.next },
  ],
});

campaignTour.addStep({
  text: 'Saiba aqui qual o valor e condições que será remunerado.',
  attachTo: {
    element: '.advertiser-info__payout',
    on: 'bottom',
  },
  scrollToHandler() {
    window.scroll(0, 100);
  },
  buttons: getTourStepButtons(campaignTour, true),
});

campaignTour.addStep({
  text: 'Conheça as regras de divulgação do anunciante.',
  attachTo: {
    element: '.advertiser-info__rules',
    on: 'bottom',
  },
  scrollToHandler() {
    window.scroll(0, 100);
  },
  buttons: getTourStepButtons(campaignTour),
});

campaignTour.addStep({
  text: 'Selecione o melhor formato que se adeque à sua página online.',
  attachTo: {
    element: '.campaign-tabs .tabs-controls',
    on: 'right',
  },
  scrollToHandler() {
    window.scroll(0, 250);
  },
  buttons: getTourStepButtons(campaignTour),
});

campaignTour.addStep({
  text: 'Links prontos ou personalizados, ideal para a divulgação em sites, redes sociais e blogs.',
  attachTo: {
    element: '.button-links',
    on: 'auto',
  },
  scrollToHandler() {
    window.scroll(0, 300);
  },
  buttons: getTourStepButtons(campaignTour),
});
campaignTour.addStep({
  text: 'Banners prontos para a divulgação em sua página. Ideal para sites e blogs.',
  attachTo: {
    element: '.button-banners',
    on: 'auto',
  },
  scrollToHandler() {
    window.scroll(0, 450);
  },
  buttons: getTourStepButtons(campaignTour),
});

campaignTour.addStep({
  text: 'Divulgue através do envio de e-mail marketing.',
  attachTo: {
    element: '.button-emarketing',
    on: 'auto',
  },
  scrollToHandler() {
    window.scroll(0, 450);
  },
  buttons: getTourStepButtons(campaignTour),
});

campaignTour.addStep({
  text: 'Preencha o formulário para gerar o link ou código da peça',
  attachTo: {
    element: '.tabs-content',
    on: 'auto',
  },
  scrollToHandler() {
    window.scroll(0, 250);
  },
  buttons: getTourStepButtons(campaignTour, false, true),
  advanceOn: { selector: '.tabs-content', event: 'click' },
});

export default campaignTour;
